import { CommonModule, NgFor, NgIf } from '@angular/common'
import { AfterViewInit, Component, inject, OnInit } from '@angular/core'
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe'
import { PaginationComponent } from '../../template/pagination/pagination.component'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { ToastrService } from 'ngx-toastr'
import { eps } from '../../../../services/url.service'
import { environment } from '../../../../../environments/environment'
import { Store } from '@ngrx/store'
import { loadBusinesses } from '../../../../store/business/business.actions'
import {
  BehaviorSubject,
  combineLatest,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  Observable,
  of,
  shareReplay,
  skip,
  Subject,
  switchMap,
  take,
  tap
} from 'rxjs'
import { selectBusinesses } from '../../../../store/business/business.reducer'
import { PAGE_LIMIT } from '../../../../store/state.constants'
import { Business } from '../../../../store/business/business.state'
import { selectAdminAttendanceData } from '../../../../store/clockIn-clockOut/clockIn-clockOut.selectors'
import { Router, RouterModule } from '@angular/router'
import {
  ClockInClockOut,
  ClockInClockOutAdminData
} from '../../../../store/clockIn-clockOut/clockIn-clockOut.state'
import {
  clearAdminAttendances,
  loadAdminAttendances,
  loadAttendances,
  loadEmployeeAttendance
} from '../../../../store/clockIn-clockOut/clockIn-clockOut.actions'
import { selectUser } from '../../../../store/auth/auth.selectors'
import { AuthState } from '../../../../store/auth/auth.state'
import { UtilsService } from '../../../../services/utils.service'
import { SharedModule } from '../../../../shared/shared.module'
import { FormsModule } from '@angular/forms'
import dayjs, { Dayjs } from 'dayjs'
import { LoaderComponent } from '../../../../shared/components/loader/loader.component'

declare var $: any

@Component({
  selector: 'app-attendance-list',
  imports: [
    RouterModule,
    NgFor,
    NgIf,
    FormsModule,
    CommonModule,
    CapitalizePipe,
    PaginationComponent,
    SharedModule,
    LoaderComponent
  ],
  templateUrl: './attendance-list.component.html',
  styleUrl: './attendance-list.component.scss'
})
export class AttendanceListComponent implements OnInit, AfterViewInit {
  private store = inject(Store)
  private modalService = inject(NgbModal)
  toastr = inject(ToastrService)
  eps = eps
  //public daysInMonth: number[] = [] // Declare an array of numbers
  attendanceData$!: Observable<{
    totalCount: number
    clockinclockouts: ClockInClockOut[]
    adminData: ClockInClockOutAdminData
  }>
  businessList$!: Observable<Business[]>
  clockInOutAnalytics$!: Observable<ClockInClockOutAdminData> //clockResponse
  employeeClockInOut$: Observable<ClockInClockOut[]> = of([])
  private loadTrigger$ = new Subject<void>()

  defaultImg = '../../../../assets/img/user.jpg'

  totalCount = 0
  currentPage = 1
  // pageLimit = PAGE_LIMIT
  pageLimit = 10
  pageLastRecord = 0
  apiEndpoint = environment.apiBaseUrl
  search = ''
  selectedBusinessId$ = new BehaviorSubject<string | null>(null)
  isAttendanceLoading = true
  //selectedAttendanceStatus = ''
  user: AuthState['user'] | null = null
  businessIdss!: string[]
  selectedStatus$ = new BehaviorSubject<string | null>(null)
  searchSubject = new BehaviorSubject<string>('')

  selectedDate: {
    startDate: Dayjs
    endDate: Dayjs
  } = {
    startDate: dayjs(),
    endDate: dayjs()
  }

  // Add this property
  selectedDateForNav: string = dayjs().format('YYYY-MM-DD')
  // Replace the existing selectedDate property with this:
  selectedFromDate: Date = new Date()
  selectedToDate: Date = new Date()

  // constructor(
  //   private router: Router,
  //   private utilService: UtilsService
  // ) {
  //   this.store
  //     .select(selectUser)
  //     .pipe(
  //       take(1),
  //       tap(user => {
  //         this.user = user
  //         const businessIds = user?.businessIds // your array of business IDs
  //         if (businessIds && businessIds.length) {
  //           this.businessIdss = businessIds
  //           // const paramString = `businessIds=${businessIds.join(',')}`
  //           // this.store.dispatch(loadBusinesses({ params: paramString }))
  //           // loadAttendances({
  //           //   range: { fromDate: new Date(), toDate: new Date() },
  //           //   filter: { businessId: businessIds[0] }
  //           // })
  //         }
  //         this.loadAllBusinesses() // Load all businesses initially
  //         if (businessIds?.length) {
  //           const firstBusinessId = businessIds[0]
  //           this.businessIdss = businessIds
  //           this.store.dispatch(
  //             loadAttendances({
  //               range: { fromDate: new Date(), toDate: new Date() },
  //               filter: { businessId: firstBusinessId }
  //             })
  //           )
  //         }
  //         // if (businessIds?.length) {
  //         //   const firstBusinessId = businessIds[0]
  //         //   this.businessIdss = businessIds
  //         //   this.selectedBusinessId$.next(firstBusinessId)
  //         //   this.loadFilteredAttendances()
  //         // }
  //         //  ONLY THIS
  //         if (businessIds?.length) {
  //           this.businessIdss = businessIds

  //           // default → no filter
  //           this.selectedBusinessId$.next(null)
  //           this.selectedStatus$.next(null)

  //           this.loadFilteredAttendances()
  //         }
  //         // this.loadAttendances()
  //       })
  //     )
  //     .subscribe()

  //   this.store.dispatch(loadAttendances({ range: { fromDate: new Date(), toDate: new Date() } }))
  // }

  constructor(
    private router: Router,
    private utilService: UtilsService
  ) {
    this.store
      .select(selectUser)
      .pipe(
        take(1),
        tap(user => {
          this.user = user
          const businessIds = user?.businessIds || []
          const isAdmin = user?.userRoles?.some(ur => ur.role?.name === 'Admin')
          this.businessIdss = businessIds
          if (isAdmin) {
            // ADMIN → NO businessId
            this.selectedBusinessId$.next(null)
          } else if (businessIds.length) {
            // BUSINESS USER → set first businessId
            this.selectedBusinessId$.next(businessIds[0])
          }
          this.loadFilteredAttendances()
          // this.loadAllBusinesses()
        })
      )
      .subscribe()
  }

  ngOnInit(): void {
    // this.store.dispatch(loadAttendances({ range: { fromDate: new Date(), toDate: new Date() } }))
    // this.store.dispatch(loadBusinesses({ params: null, page: 1, limit: 10 }))
    this.attendanceData$ = this.store.select(selectAdminAttendanceData).pipe(
      tap(d => {
        this.totalCount = d.totalCount
        this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, d.totalCount)
        // this.isAttendanceLoading = false // if you use this then laoder not showing
      }),
      shareReplay(1)
    )

    this.loadTrigger$
      .pipe(switchMap(() => this.attendanceData$.pipe(skip(1), take(1))))
      .subscribe(() => {
        this.isAttendanceLoading = false
      })
    // this.loadFilteredAttendances()

    // this.employeeClockInOut$ = this.attendanceData$.pipe(
    //   filter(data => !!data && !!data.clockinclockouts),
    //   switchMap(data =>
    //     this.selectedBusinessId$.pipe(
    //       map(selectedBusinessId => {
    //         const filtered = data.clockinclockouts.filter(item => {
    //           return !selectedBusinessId || item.user.businessId === selectedBusinessId
    //         })
    //         // const filtered = data.clockinclockouts.filter(item=>{
    //         //   return !selectedBusinessId || item.user.businessId === selectedBusinessId
    //         // })

    //         return Object.values(
    //           filtered.reduce((acc: Record<string, ClockInClockOut>, item) => {
    //             acc[item.userId] = item
    //             return acc
    //           }, {})
    //         )
    //       })
    //     )
    //   )
    // )

    // this.employeeClockInOut$ = combineLatest([
    //   this.attendanceData$,
    //   this.selectedBusinessId$,
    //   this.selectedStatus$,
    //   this.searchSubject.pipe(debounceTime(300), distinctUntilChanged())
    // ]).pipe(
    //   map(([data, selectedBusinessId, selectedStatus, search]) => {
    //     if (!data?.clockinclockouts?.length) {
    //       return []
    //     }

    //     const searchTerm = search?.toLowerCase()?.trim()

    //     return data.clockinclockouts.filter(item => {
    //       if (!item.user) return false

    //       if (selectedBusinessId && item.user.businessId !== selectedBusinessId) {
    //         return false
    //       }

    //       if (selectedStatus && item.workStatus !== selectedStatus) {
    //         return false
    //       }

    //       if (searchTerm) {
    //         const fullName =
    //           `${item.user.firstName || ''} ${item.user.lastName || ''}`.toLowerCase()

    //         if (!fullName.includes(searchTerm)) {
    //           return false
    //         }
    //       }

    //       return true
    //     })
    //   })
    // )

    this.employeeClockInOut$ = combineLatest([
      this.attendanceData$,
      this.selectedBusinessId$,
      this.selectedStatus$,
      this.searchSubject.pipe(debounceTime(300), distinctUntilChanged())
    ]).pipe(
      map(([data, selectedBusinessId, selectedStatus, search]) => {
        // If business OR status not selected → return empty
        // if (!selectedBusinessId || !selectedStatus) {
        //   return []
        // }

        if (!data?.clockinclockouts?.length) {
          return []
        }

        // const searchTerm = search?.toLowerCase()?.trim()

        // const filtered = data.clockinclockouts.filter(item => {
        //   return item.user.businessId === selectedBusinessId
        // })

        // const filtered = data.clockinclockouts.filter(item => {
        //   if (!item.user) return false
        //   if (!selectedBusinessId) {
        //     return false
        //   }
        //   return item.user.businessId === selectedBusinessId
        // })

        // const filtered = data.clockinclockouts.filter(item => {
        //   if (!item.user) return false
        //   //  Always restrict to owner's businesses
        //   // if (!this.businessIdss?.includes(item.user.businessId)) {
        //   //   return false
        //   // }
        //   const isAdmin = this.user?.userRoles?.some(ur => ur.role?.name === 'Admin')
        //   if (!isAdmin) {
        //     if (!this.businessIdss?.includes(item.user.businessId)) {
        //       return false
        //     }
        //   }
        //   //  Apply business filter only if selected
        //   if (selectedBusinessId && item.user.businessId !== selectedBusinessId) {
        //     return false
        //   }
        //   //  Apply status filter only if selected
        //   if (selectedStatus) {
        //     if (selectedStatus === 'Present') {
        //       if (!item.clockIn) {
        //         return false
        //       }
        //     } else {
        //       if (item.workStatus !== selectedStatus) {
        //         return false
        //       }
        //     }
        //   }
        //   return true
        // })

        const allowedStatuses = [
          'Clock In/Out',
          'Absent',
          'Absent First Half',
          'Absent Second Half',
          'Leave',
          'Leave First Half',
          'Leave Second Half',
          'Late',
          'Early',
          'Holiday',
          'Weekly Off',
          'Present',
          'Present for Half Day',
          'Present - Regularized for Half Day',
          'Present - Regularized'
        ]

        const filtered = data.clockinclockouts.filter(item => {
          if (!item.user) return false

          // Search Filter
          // if (searchTerm) {
          //   const fullName =
          //     `${item.user.firstName || ''} ${item.user.lastName || ''}`.toLowerCase()
          //   const email = item.user.email?.toLowerCase() || ''
          //   const mobile = item.user.mobile?.toLowerCase?.() || ''
          //   const employeeId = item.user.id?.toLowerCase?.() || ''
          //   const matches =
          //     fullName.includes(searchTerm) ||
          //     email.includes(searchTerm) ||
          //     mobile.includes(searchTerm) ||
          //     employeeId.includes(searchTerm)
          //   if (!matches) return false
          // }

          // Status Filter
          if (!allowedStatuses.includes(item.workStatus)) {
            return false
          }

          // Role Filter
          // const isAdmin = this.user?.userRoles?.some(ur => ur.role?.name === 'Admin')

          // if (!isAdmin) {
          //   if (!this.businessIdss?.includes(item.user.businessId)) {
          //     return false
          //   }
          // }

          // Buisness Filter
          if (selectedBusinessId && item.user.businessId !== selectedBusinessId) {
            return false
          }

          // WorkStatus Filter
          if (selectedStatus) {
            if (selectedStatus === 'Present') {
              if (!item.clockIn) return false
            } else {
              if (item.workStatus !== selectedStatus) return false
            }
          }

          return true
        })

        // return Object.values(
        //   filtered.reduce((acc: Record<string, ClockInClockOut>, item) => {
        //     acc[item.userId] = item
        //     return acc
        //   }, {})
        // )
        // const uniqueData = Object.values(
        //   filtered.reduce((acc: Record<string, ClockInClockOut>, item) => {
        //     const existing = acc[item.userId]

        //     if (!existing) {
        //       acc[item.userId] = item
        //       return acc
        //     }

        //     const priority = (status: string) => {
        //       if (!status) return 0
        //       if (status === 'Leave - Requested') return -1
        //       if (status.includes('Leave')) return 4
        //       if (status === 'Absent') return 3
        //       if (status === 'Late') return 2
        //       if (status === 'Clock In/Out') return 1
        //       if (status === 'Break') return 0
        //       return 0
        //     }

        //     // compare priority
        //     if (priority(item.workStatus) > priority(existing.workStatus)) {
        //       acc[item.userId] = item
        //     }

        //     return acc
        //   }, {})
        // )
        // this.totalCount = uniqueData.length

        // this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)

        // return uniqueData.slice(
        //   (this.currentPage - 1) * this.pageLimit,
        //   this.currentPage * this.pageLimit
        // )

        // Grouping
        // const groupedData = Object.values(
        //   filtered.reduce((acc: any, item) => {
        //     if (!acc[item.userId]) {
        //       acc[item.userId] = {
        //         ...item,
        //         workStatus: new Set<string>()
        //       }
        //     }
        //     // const status = item.workStatus?.includes('Leave')
        //     //   ? 'Leave'
        //     //   : item.workStatus === 'ClockIn'
        //     //     ? 'Clock In/Out'
        //     //     : item.workStatus
        //     // let status = item.workStatus
        //     // if (selectedStatus === 'Present' && item.clockIn) {
        //     //   status = 'Present'
        //     // } else if (status?.includes('Leave')) {
        //     //   status = 'Leave'
        //     // } else if (status === 'ClockIn') {
        //     //   status = 'Clock In/Out'
        //     // }
        //     // const status = item.workStatus
        //     // if (status === 'ClockIn' || status === 'Clock In/Out') {
        //     //   acc[item.userId].workStatus.add('Present')
        //     // } else {
        //     //   acc[item.userId].workStatus.add(status)
        //     // }
        //     // if (status === 'ClockIn' || status === 'Clock In/Out') {
        //     //   acc[item.userId].workStatus.add('Present')
        //     // } else if (status === 'Late') {
        //     //   acc[item.userId].workStatus.add('Present') // ✅ Late = Present bhi hai
        //     //   acc[item.userId].workStatus.add('Late') // ✅ Late badge alag bhi dikhao
        //     // } else {
        //     //   acc[item.userId].workStatus.add(status)
        //     // }
        //     const statuses = (
        //       item['workStatuses']?.length ? item['workStatuses'] : [item.workStatus]
        //     ).filter((status: string) => status !== 'Clock In/Out' && status !== 'ClockIn')

        //     statuses.forEach((status: string) => {
        //       acc[item.userId].workStatus.add(status)
        //     })
        //     // if (item.clockIn && status !== 'Leave' && status !== 'Absent' && status !== 'Late') {
        //     //   acc[item.userId].workStatus.add('Present')
        //     // }
        //     // acc[item.userId].workStatus.add(status)
        //     return acc
        //   }, {})
        // ).map((item: any) => ({
        //   ...item,
        //   workStatus: Array.from(item.workStatus).filter(
        //     status => status !== 'Clock In/Out' && status !== 'ClockIn'
        //   )
        // }))

        // const groupedData = Object.values(
        //   filtered.reduce((acc: any, item) => {
        //     if (!acc[item.userId]) {
        //       acc[item.userId] = {
        //         ...item,
        //         workStatus: new Set<string>()
        //       }
        //     }

        //     const statuses = item['workStatuses']?.length ? item['workStatuses'] : [item.workStatus]

        //     statuses.forEach((status: string) => {
        //       if (status === 'Clock In/Out' || status === 'ClockIn') {
        //         acc[item.userId].workStatus.add('Present')
        //       } else {
        //         acc[item.userId].workStatus.add(status)
        //       }
        //     })

        //     return acc
        //   }, {})
        // ).map((item: any) => ({
        //   ...item,
        //   workStatuses: (Array.from(item.workStatus) as string[]).filter(
        //     status => status !== 'Clock In/Out' && status !== 'ClockIn'
        //   )
        // }))

        const isSelectedDateToday =
          this.selectedToDate && dayjs(this.selectedToDate).isSame(dayjs(), 'day')

        const groupedData = Object.values(
          filtered.reduce((acc: any, item) => {
            if (!acc[item.userId]) {
              acc[item.userId] = {
                ...item,
                workStatus: new Set<string>()
              }
            }

            const statuses = item['workStatuses']?.length ? item['workStatuses'] : [item.workStatus]

            statuses.forEach((status: string) => {
              if (status === 'Clock In/Out' || status === 'ClockIn') {
                acc[item.userId].workStatus.add('Present')
              } else {
                acc[item.userId].workStatus.add(status)
              }
            })

            acc[item.userId].latestClockIn = item.clockIn
            acc[item.userId].latestClockOut = item.clockOut

            return acc
          }, {})
        ).map((item: any) => {
          let workStatuses = (Array.from(item.workStatus) as string[]).filter(
            status => status !== 'Clock In/Out' && status !== 'ClockIn'
          )

          if (workStatuses.includes('Present')) {
            if (isSelectedDateToday) {
              if (!item.latestClockIn) {
                // No clockIn at all → Absent
                workStatuses = workStatuses.filter(s => s !== 'Present')
                if (!workStatuses.includes('Absent')) {
                  workStatuses.push('Absent')
                }
              }
              // If clockIn exists → keep 'Present' (regardless of clockOut)
            } else {
              if (item.latestClockIn && item.latestClockOut) {
                // Both exist → Keep 'Present'
              } else if (item.latestClockIn && !item.latestClockOut) {
                //  ClockIn exists, no ClockOut → Show 'Clock In/Out' (not Present)
                workStatuses = workStatuses.filter(s => s !== 'Present')
                workStatuses.push('Clock In/Out') // Show "Clock In/Out" instead
              } else {
                //  Neither exists → Show 'Absent'
                workStatuses = workStatuses.filter(s => s !== 'Present')
                if (!workStatuses.includes('Absent')) {
                  workStatuses.push('Absent')
                }
              }
            }
          }

          if (
            workStatuses.includes('Absent') &&
            workStatuses.some(status => status !== 'Absent') &&
            !workStatuses.includes('Present')
          ) {
            workStatuses = workStatuses.filter(status => status !== 'Absent')
          }

          if (
            workStatuses.includes('Present for Half Day') ||
            workStatuses.includes('Present - Regularized') ||
            workStatuses.includes('Present - Regularized for Half Day')
          ) {
            workStatuses = workStatuses.filter(status => status !== 'Present')
          }

          return {
            ...item,
            workStatuses
          }
        })

        // Pagination
        // this.totalCount = groupedData.length
        this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
        // return groupedData.slice(
        //   (this.currentPage - 1) * this.pageLimit,
        //   this.currentPage * this.pageLimit
        // )
        // API already returns paginated data
        return groupedData
      }),
      shareReplay(1)
    )

    this.clockInOutAnalytics$ = this.attendanceData$.pipe(
      filter(data => !!data && !!data.adminData),
      map(data => {
        return (data && data.adminData) || {}
      })
    )
    this.businessList$ = this.store.select(selectBusinesses)

    this.store
      .select(selectUser)
      .pipe(take(1))
      .subscribe(user => {
        const businessIds = user?.businessIds // your array of business IDs
        if (businessIds && businessIds.length) {
          this.businessIdss = businessIds
          const paramString = `businessIds=${businessIds.join(',')}`
          this.store.dispatch(loadBusinesses({ params: paramString }))
        }

        // if(businessIds && businessIds.length){
        //   this.businessIdss = businessIds
        //   const paramString =  `bussinessIds= ${businessIds.join(',')}`
        //   this.store.dispatch(loadBusinesses({params: paramString}))
        // }
        else {
          this.loadAllBusinesses() // Load all businesses initially
        }
      })

    //this.generateDaysInMonth()
    //this.getTodayAttendance()//Dispatch loadAttendances with desired filters

    this.searchSubject.pipe(debounceTime(500), distinctUntilChanged()).subscribe(() => {
      this.loadFilteredAttendances()
    })
  }

  ngAfterViewInit() {
    const today = new Date()

    $('#attendanceSingleDate').daterangepicker({
      singleDatePicker: true, // single date only
      autoUpdateInput: false,
      showDropdowns: false,
      autoApply: true,
      startDate: today,
      maxDate: today,
      locale: {
        format: 'DD/MM/YYYY'
      }
    })

    // Default value set karo
    const pad = (n: number) => ('0' + n).slice(-2)
    const formatted = `${pad(today.getDate())}/${pad(today.getMonth() + 1)}/${today.getFullYear()}`
    $('#attendanceSingleDate').val(formatted)

    // Date select hone par event
    // $('#attendanceSingleDate').on('apply.daterangepicker', (ev: any, picker: any) => {
    //   const formatted = picker.startDate.format('DD/MM/YYYY')
    //   $('#attendanceSingleDate').val(formatted)

    //   const fromDate = picker.startDate.toDate()
    //   const toDate = picker.startDate.toDate() // single date = same date

    //   this.selectedDateForNav = picker.startDate.format('YYYY-MM-DD')

    //   this.store.dispatch(
    //     loadAttendances({
    //       range: { fromDate, toDate },
    //       filter: {
    //         businessId: this.selectedBusinessId$.value ?? undefined,
    //         workStatus: this.selectedStatus$.value ?? undefined
    //       }
    //     })
    //   )
    // })

    $('#attendanceSingleDate').on('apply.daterangepicker', (ev: any, picker: any) => {
      const formatted = picker.startDate.format('DD/MM/YYYY')
      $('#attendanceSingleDate').val(formatted)
      // this.selectedFromDate = picker.startDate.startOf('day').toDate()
      // this.selectedToDate = picker.startDate.endOf('day').toDate()
      this.selectedToDate = picker.startDate.endOf('day').toDate()
      this.selectedDateForNav = picker.startDate.format('YYYY-MM-DD')
      this.currentPage = 1
      this.loadFilteredAttendances()
    })
  }

  // Method to generate days of the month dynamically
  //generateDaysInMonth(): void {
  //  const now = new Date()
  //  const year = now.getFullYear()
  //  const month = now.getMonth() // 0 for January, 11 for December
  //  const days = new Date(year, month + 1, 0).getDate() // Get the number of days in the current month

  //  for (let day = 1; day <= days; day++) {
  //    this.daysInMonth.push(day)
  //  }
  //}

  // Method to check if there is a clock-in on a specific day
  isClockInOnDay(clockinout: any[], day: number): boolean {
    return clockinout.some(record => {
      const clockInDate = new Date(record.clockIn)
      const clockInDay = clockInDate.getDate() // Use getDate() to get the day of the month
      return clockInDay === day // Compare the day of the month
    })
  }

  // Method to check if the day is not in the future
  isNotFutureDay(day: number): boolean {
    const today = new Date()
    const todayDay = today.getDate() // Get today's day of the month
    return day <= todayDay // Return true if the day is not in the future
  }

  // Method to be called when the check icon is clicked
  //getDateClockIn(employeeId: string, day: number): void {
  //  const date = new Date() // Use the current date for this example
  //  const setdate = date.setDate(day) // Set the date from the loop (could also be passed as a parameter)
  //  const newDate = date.toISOString().split('T')[0]
  //  // Construct the payload to send
  //  // const payload = {
  //  // employeeId: employeeId,
  //  // date: date.toISOString().split('T')[0] // Convert to ISO string format for standard date format
  //  // };
  //  // console.log('payload', payload)
  //  this.punchService.punchApi.getDateClockIn(employeeId, newDate).subscribe(res => {
  //    this.employeeClockInOut = res.rows
  //    this.totalWorkHours = this.employeeClockInOut.reduce(
  //      (total, entry) => total + parseFloat(entry.workHour),
  //      0
  //    )
  //  })
  //}

  getFormatedTime(clockIn: string | number | Date) {
    // const clockIn = '2024-12-19T04:59:52.891Z';  // Example ISO timestamp
    const date = new Date(clockIn) // Convert the string to a Date object

    // Format time as HH:mm AM/PM
    // const hours = date.getUTCHours();
    // const minutes = date.getUTCMinutes();
    // Get local hours and minutes
    const hours = date.getHours()
    const minutes = date.getMinutes()
    const formattedTime = `${hours % 12 || 12}:${minutes < 10 ? '0' : ''}${minutes} ${hours >= 12 ? 'PM' : 'AM'}`
    return formattedTime
  }

  //pagination
  onPageChange(newPage: number): void {
    if (newPage > 0) {
      this.currentPage = newPage
      this.loadFilteredAttendances()
      this.updatePageLastRecord()
      // this.selectedBusinessId$.next(this.selectedBusinessId$.value)
    }
  }

  //modal open
  openBusiness(content: unknown) {
    this.modalService.open(content, { scrollable: false, centered: true, size: 'lg' })
  }

  onClose() {
    this.modalService.dismissAll()
  }

  // handleSortChange(event: Event): void {
  //   const selectElement = event.target as HTMLSelectElement
  //   const selectedValue = selectElement.value || null
  //   this.selectedBusinessId$.next(selectedValue)
  // }

  handleSortChange(event: Event): void {
    // const target = event.target as HTMLSelectElement
    // const value = target.value || undefined

    // this.selectedBusinessId$.next(value ?? null)

    // this.store.dispatch(
    //   loadAttendances({
    //     range: { fromDate: new Date(), toDate: new Date() },
    //     filter: { businessId: value }
    //   })
    // )
    const target = event.target as HTMLSelectElement
    const value = target.value || null
    this.currentPage = 1
    this.selectedBusinessId$.next(value)
    this.loadFilteredAttendances()
  }

  // handleStatusChange(event: Event): void {
  //   const target = event.target as HTMLSelectElement
  //   //this.selectedAttendanceStatus = target.value
  //   //this.getTodayAttendance()
  //   this.store.dispatch(
  //     loadAttendances({
  //       range: { fromDate: new Date(), toDate: new Date() },
  //       filter: { workStatus: target.value }
  //     })
  //   )
  // }

  handleStatusChange(event: Event): void {
    // const target = event.target as HTMLSelectElement
    // const value = target.value
    // this.selectedStatus$.next(value || null)

    // if (value) {
    //   this.store.dispatch(
    //     loadAttendances({
    //       range: { fromDate: new Date(), toDate: new Date() },
    //       filter: { workStatus: value }
    //     })
    //   )
    // } else {
    //   this.store.dispatch(
    //     loadAttendances({
    //       range: { fromDate: new Date(), toDate: new Date() },
    //       filter: { workStatus: value }
    //     })
    //   )
    // }
    const target = event.target as HTMLSelectElement
    const value = target.value || null
    this.currentPage = 1
    this.selectedStatus$.next(value)
    this.loadFilteredAttendances()
  }

  private loadFilteredAttendances() {
    this.isAttendanceLoading = true
    const businessId = this.selectedBusinessId$.value
    const workStatus = this.selectedStatus$.value
    const search = this.searchSubject.value
    const filter: any = {}
    if (businessId) filter.businessId = businessId
    if (workStatus) {
      filter.workStatus = workStatus === 'Present' ? 'ClockIn' : workStatus
    }
    if (workStatus) filter.workStatus = workStatus
    if (search) filter.search = search
    // if (businessId) {
    //   filter.businessId = businessId
    // }
    // if (workStatus) {
    //   filter.workStatus = workStatus
    // }
    // this.store.dispatch(clearAdminAttendances())
    this.store.dispatch(
      loadAdminAttendances({
        range: {
          // fromDate: new Date(),
          // fromDate: this.selectedFromDate,
          toDate: this.selectedToDate
        },
        filter,
        pagination: {
          page: this.currentPage,
          limit: this.pageLimit
        }
      })
    )
    this.loadTrigger$.next()
  }

  loadAllBusinesses() {
    const params: any = {}
    if (this.businessIdss?.length) {
      params.businessIds = this.businessIdss.join(',')
    }

    this.store.dispatch(
      loadBusinesses({
        params: new URLSearchParams(params).toString()
      })
    )
  }

  private updatePageLastRecord() {
    this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
  }

  loadAttendances() {
    const params: any = {}
    // params.userId = this.user?.id
    // if (this.leaveType ) {
    //   params.leaveType = this.leaveType
    // }
    // if (this.status) {
    //   params.workStatus = this.status
    // }
    // if (this.dateRange?.startDate && this.dateRange?.endDate) {
    //   params.fromDate = this.dateRange.startDate.format('YYYY-MM-DD')
    //   params.toDate = this.dateRange.endDate.format('YYYY-MM-DD')
    // }
    this.store.dispatch(
      loadEmployeeAttendance({
        id: this.user?.id,
        // params: null
        params: new URLSearchParams(params).toString()
      })
    )
  }

  getDashboardRoute(): string {
    // return this.user?.role.name === 'Admin' ? eps.dashboardPath : eps.employeeDashboardPath
    return this.utilService.getDashboardRoute()
  }

  // onPageLimitChange() {
  //   this.currentPage = 1
  //   this.updatePageLastRecord()
  //   this.selectedBusinessId$.next(this.selectedBusinessId$.value)
  // }

  onPageLimitChange() {
    this.currentPage = 1
    this.loadFilteredAttendances()
  }

  // getStatusColor(status: string): string {
  //   switch (status) {
  //     case 'Absent':
  //     case 'Absent First Half':
  //     case 'Absent Second Half':
  //       return '#FF5252'
  //     case 'Late':
  //       return '#FFA500'
  //     case 'Leave':
  //     case 'Leave First Half':
  //     case 'Leave Second Half':
  //       return '#FFAB40'
  //     case 'ClockIn':
  //     case 'Clock In/Out':
  //       return '#FFBC80'
  //     case 'Present':
  //       return '#CCFF90'
  //     case 'Comp Off':
  //       return '#81D4FA'
  //     case 'Date of Joining':
  //       return '#1E88E5'
  //     case 'Early':
  //       return '#4ECDC4'
  //     case 'Holiday':
  //       return '#B39DDB'
  //     case 'Weekly Off':
  //       return '#CFB58C'
  //     default:
  //       return '#607d8b'
  //   }
  // }

  setCurrentPage() {
    this.currentPage = 1
  }

  // onSearchChange() {
  //   this.currentPage = 1
  //   this.searchSubject.next(this.search)
  //   this.loadFilteredAttendances()
  // }

  onSearchChange() {
    this.currentPage = 1
    this.searchSubject.next(this.search)
  }

  getStatusColor(status: string): string {
    const presentStatuses = [
      'Present',
      'Present Half',
      'Present for Half Day',
      'Present - Regularized for Half Day',
      'Present - Regularized',
      'Present - Regularized for First Half Day',
      'Present - Regularized for Second Half Day'
    ]

    const absentStatuses = ['Absent', 'Absent First Half', 'Absent Second Half']

    const leaveStatuses = ['Leave', 'Leave First Half', 'Leave Second Half']
    const clockInStatuses = ['ClockIn', 'Clock In/Out']

    if (presentStatuses.includes(status)) {
      return '#CCFF90'
    }

    if (absentStatuses.includes(status)) {
      return '#FF5252'
    }

    if (leaveStatuses.includes(status)) {
      return '#FFAB40'
    }

    if (clockInStatuses.includes(status)) {
      return '#FFBC80'
    }

    switch (status) {
      case 'Late':
        return '#FFA500'

      case 'Comp Off':
        return '#81D4FA'

      case 'Date of Joining':
        return '#1E88E5'

      case 'Early':
        return '#4ECDC4'

      case 'Holiday':
        return '#B39DDB'

      case 'Weekly Off':
        return '#CFB58C'

      default:
        return '#607d8b'
    }
  }
}
